import React ,{useEffect} from 'react';
import { useHistory } from "react-router-dom"; 
import { useCookies } from 'react-cookie';
import CompanySignupContainer from 'components/containers/signup/CompanySignupContainer';

export default function VersionChecker(props) {
  const history = useHistory();
  const [cookies, setCookie ] = useCookies();

  const checkBuildInfo = async () =>{
    fetch(`/build-info.json`, {
      method: 'GET',
      mode: 'cors',
      headers: {
        "Content-Type": "application/json"
      }
    }).then(function(response) {
      return response.json();
    }).then(function(data){
      return buildInfoParser(data);
    })
    .catch(error => {
      console.log('build-info load error');
      console.error(error.status);
    });
  }


  const buildInfoParser = (data) =>{
    let prevBuildTime = cookies['build_time'];
    let buildTime = data['time'];

    if(prevBuildTime !== buildTime)
    {
      setCookie('build_time', buildTime, { path: '/', maxAge :60*60*24*31*12 });
      window.location.reload();
    }
    else
    {
      setCookie('build_time', buildTime, { path: '/', maxAge :60*60*24*31*12 });
    }
  }

  const onFocusHandler = () => {
    checkBuildInfo();
  }
  /*Dynamic import asset checker*/ 
  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    // let visibilityChange = null;
    // if (typeof document.hidden !== "undefined") { // Opera 12.10 and Firefox 18 and later support 
    //   visibilityChange = "visibilitychange";
    // } else if (typeof document.msHidden !== "undefined") { 
    //   visibilityChange = "msvisibilitychange";        
    // } else if (typeof document.webkitHidden !== "undefined") { 
    //   visibilityChange = "webkitvisibilitychange";
    // }
    // else{
    //   visibilityChange = "visibilitychange";
    // }
    
    checkBuildInfo();
    history.listen((location, action) => {
      checkBuildInfo();
    });
    // window.addEventListener(visibilityChange, onFocusHandler)

    // return function cleanup() {
    //   window.removeEventListener(visibilityChange, onFocusHandler)
    // };
  },[]);

  return (
    <></>
  );
}
